import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from '../Components/Message/errorMessage';
import CheckoutSteps from '../Components/CheckoutStep/CheckoutSteps';
import { createOrder } from '../Actions/orderAction';
import * as routes from '../Constants/routes';
import { interpolate } from '../utils/string';
import * as orderConstants from '../Constants/orderConstants';
import { Button, CircularProgress, makeStyles } from '@material-ui/core/';

const useStyles = makeStyles((theme) => ({
  prgressColor: {
    color: '#000000',
  },
}));

const PlaceOrder = ({ history }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const cart = useSelector((state) => state.cart);
  // const shipping = useSelector((state) => state.shipping);

  const redirectUser = !localStorage.getItem('shippingAddress')
    ? routes.SHIPPINGS
    // : !localStorage.getItem('notes')
    // ? routes.CART
    : null;

  if (redirectUser) {
    history.push(redirectUser);
  }

  //   Calculate prices
  const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  cart.itemsPrice = addDecimals(cart.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0));
  cart.shippingPrice = addDecimals(cart.itemsPrice > 0 ? 40 : 40);
  cart.taxPrice = addDecimals(Number((0 * cart.itemsPrice).toFixed(2)));
  cart.totalPrice = (Number(cart.itemsPrice) + Number(cart.shippingPrice) + Number(cart.taxPrice)).toFixed(2);

  const orderCreate = useSelector((state) => state.createOrder);
  const { order, success, error, loading } = orderCreate;

  useEffect(() => {
    if (success) {
      history.push({
        pathname: interpolate(routes.ORDER, { orderId: order._id }),
      });
    }
    // eslint-disable-next-line
  }, [history, success]);

  const placeOrderHandler = () => {
    dispatch(
      createOrder({
        orderItems: cart.cartItems,
        shipping: cart.shippingAddress,
        // notess: cart.notes,
        /* payment: {
          paymentMethod: cart.paymentMethod,
        }, */
        itemsPrice: cart.itemsPrice,
        shippingPrice: cart.shippingPrice,
        taxPrice: cart.taxPrice,
        totalPrice: cart.totalPrice,
      })
    );
  };

  return (
    <>
      {error && <ErrorMessage header="Create Order Error" message={error} reset={orderConstants.CREATE_ORDER_RESET} />}
      <CheckoutSteps step1 step2 step3 />
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Shipping</h2>
              <p>
                <strong>Address:</strong>
                {cart.shippingAddress.area}, {cart.shippingAddress.road}, {cart.shippingAddress.landmark}, {cart.shippingAddress.building}, {cart.shippingAddress.floorNo}
                ,{cart.shippingAddress.houseNo}
              </p>
              
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Order Items</h2>
              {!cart.cartItems ? (
                <>Your cart is empty</>
              ) : (
                <ListGroup variant="flush">
                  {cart.cartItems.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image src={item.productImage} alt={item.productName} fluid rounded />
                        </Col>
                        <Col>
                          <Link
                            to={interpolate(routes.PRODUCT, {
                              productId: item.productId,
                            })}
                          >
                            {item.productName}
                          </Link>
                        </Col>
                        <Col md={4}>
                          {item.qty} x Ksh{item.price} = Ksh{item.qty * item.price}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}

                </ListGroup>
              )}
           
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Order Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Items</Col>
                  <Col>Ksh{cart.itemsPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Shipping</Col>
                  <Col>Ksh{cart.shippingPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Tax</Col>
                  <Col>Ksh{cart.taxPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>Ksh{cart.totalPrice}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={!cart.cartItems || loading}
                  onClick={placeOrderHandler}
                >
                  {loading ? <CircularProgress color="inherit" className={classes.prgressColor} /> : <>Place Order</>}
                </Button>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PlaceOrder;
